var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-weight-bold caption black--text mb-5 mt-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }